import { Pipe, PipeTransform } from '@angular/core';

import { LanguageService } from '../services/language.service';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly language: LanguageService) {}

  transform(key: string | null | undefined, fallback = ''): string {
    return this.language.translate(key, fallback);
  }
}
